import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { eur, eur0, dateTime, W_STATUS, W_FLOW } from "../lib/fmt";
import { useData } from "../context/Data";
import { useGo } from "./Inicio";

export function ClaimCard({ c }) {
  const idx = W_FLOW.indexOf(c.status);
  return (
    <div className="claim-card" data-testid={`claim-${c.id}`}>
      <div className="claim-header"><b>{eur(c.amount)} → {c.crypto_amount?.toLocaleString("es-ES")} {c.coin} · {c.network}</b><span className={`state-chip ${c.status === "rechazada" ? "no_acumulable" : c.status === "pagada" ? "cobrada" : "verificada"}`}>{W_STATUS[c.status]}</span></div>
      <div className="claim-steps">{c.status === "rechazada" ? <span className="step current">Rechazada: {c.reason}</span> : W_FLOW.map((s, i) => <span key={s} className={`step ${i < idx ? "finished" : i === idx ? "current" : ""}`}>{W_STATUS[s]}</span>)}</div>
      <small className="muted">{dateTime(c.created_at)} · comisión {eur(c.fee_eur)} · {c.address.slice(0, 10)}…{c.address.slice(-6)}</small>
      {c.status === "pagada" && c.tx_hash && <small className="lime">Hash verificado: {c.tx_hash}</small>}
    </div>
  );
}

export default function Retiradas() {
  const { d } = useData();
  const go = useGo();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/me/withdrawals").then(({ data }) => setItems(data.items)).catch(() => {}); }, []);
  const paid = items.filter((i) => i.status === "pagada" && i.tx_hash);
  return (
    <>
      <div className="page-intro"><div className="eyebrow">TRANSPARENCIA Y ESTADO</div><h1>💸 Retiradas y pagos</h1><p className="lead">Consulta el recorrido de cada solicitud: solicitada → en revisión → aprobada → procesando → pagada.</p></div>
      <div className="card"><div className="flex"><h2>📦 Historial de solicitudes</h2><button className="secondary" onClick={() => go("cartera")} data-testid="retiradas-request-btn">Solicitar retirada →</button></div>
        <div className="list" data-testid="claims-list">{items.length === 0 ? <div className="empty">No has solicitado ninguna retirada.</div> : items.map((c) => <ClaimCard key={c.id} c={c} />)}</div></div>
      <div className="card" style={{ marginTop: 18 }}><h2>✅ Pagos completados</h2>
        {paid.length === 0 ? <div className="empty" data-testid="no-real-payments">Todavía no hay pagos completados para mostrar.<br /><span className="tiny">Nunca publicaremos capturas, nombres o pagos inventados.</span></div> : paid.map((c) => <ClaimCard key={c.id} c={c} />)}</div>
      <div className="notice">La retirada mínima es de {eur0(d.config.withdrawal.min_eur)} confirmados. Las retiradas se pagan en la criptomoneda y red que elijas, según las condiciones publicadas.</div>
    </>
  );
}
